// extracted by mini-css-extract-plugin
export default {"hero-section":"HeroSection_hero-section__p7k35","background":"HeroSection_background__7TQLv"};